import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { style: {"width":"80%"} }

import { reactive, onMounted } from 'vue'
  import api from '@/api/index'
  import { ElMessage, ElLoading } from 'element-plus'
  
export default /*#__PURE__*/_defineComponent({
  __name: 'Updata',
  setup(__props) {

  const searchForm = reactive({
      limit:10,
      page:1,
  })
  const form:any = reactive({
    store_id:"",
    locations_id:[],
    platform_code:10016,
    warehouse: [],
    warehouse_list: [],
    shopline_cate_id:[],
  })
  const baseData = reactive({
    sellerList:{},
    warehouselist:[],
    choosewarehouselist:[],
    shopline_cate_type:"1",
    shopline_custom_collections:[],
    shopline_smart_collections:[],
    locations_list:[],
    loading:false,
    chooseTableData:[],
  })
  const tableData:any = reactive({
      data:[],
      total:0,
  })
  const canclecateid = () => {
    form.shopline_cate_id = []
  }
  const props = {
    expandTrigger: 'hover' as const,
    multiple:true,
    label:'name',
    value:'wid',
  }
  const handleSelectionChange = (val:any) => {
    baseData.chooseTableData = val
    console.log(val,9999)
  }
  const update_shopline_products_available = () => { 
    const loading = ElLoading.service({lock: true})
    api.accessoryApi.update_shopline_products_available({data:baseData.chooseTableData}).then((res:any)=>{
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        let tabledata = tableData.data, inventory_item_ids = res.data
        tabledata.forEach(element => {
          for(let i in inventory_item_ids){
            if(element.inventory_item_id == inventory_item_ids[i].inventory_item_id && element.location_id == inventory_item_ids[i].location_id){
              element.inventory_quantity = inventory_item_ids[i].available
              element.value = 0
            }
          }
        });
        tableData.data = tabledata
      }else{
        ElMessage.error(res.message)
      }
      loading.close()
    })
  }
  const choosewids = () => {
    let wids:any = [], warehouse:any = [], warehouselist:any = baseData.warehouselist, newwarehouselist = [];
    baseData.choosewarehouselist.forEach(element => {
      wids.push(element[1])
      if(element[0] == 3){
        newwarehouselist = warehouselist[1]
        for(let i in newwarehouselist.children){
          if(newwarehouselist.children[i].wid == element[1]){
            warehouse.push({wid : newwarehouselist.children[i].wid,name : newwarehouselist.children[i].name})
          }
        }
      }else if(element[0] == 1){
        newwarehouselist = warehouselist[0]
        for(let i in newwarehouselist.children){
          if(newwarehouselist.children[i].wid == element[1]){
            warehouse.push({wid : newwarehouselist.children[i].wid,name : newwarehouselist.children[i].name})
          }
        }
      }
    });
    form.warehouse = wids
    form.warehouse_list = warehouse
  }
  const get_all_shopline_products = () => {
    const loading = ElLoading.service({lock: true})
    api.shoplineApi.get_all_shopline_products().then((res:any)=>{
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
      }else{
        ElMessage.error(res.message)
      }
      loading.close()
    })
  }

  const get_locations_list = () => {
    const loading = ElLoading.service({lock: true})
    api.shoplineApi.locations_list({seller_id:form.store_id}).then((res:any)=>{
      if(res.code==200){
        baseData.locations_list = res.data.locations
      }else{
        ElMessage.error(res.message)
      }
      loading.close()
    })
  }
  const get_custom_collections = () => {
    const loading = ElLoading.service({lock: true})
    api.shoplineApi.get_custom_collections({seller_id:form.store_id}).then((res:any)=>{
      if(res.code==200){
        baseData.shopline_custom_collections = res.data.custom_collections
      }else{
        ElMessage.error(res.message)
      }
      loading.close()
    })
  }
  const get_smart_collections = () => {
    const loading = ElLoading.service({lock: true})
    api.shoplineApi.get_smart_collections({seller_id:form.store_id}).then((res:any)=>{
      if(res.code==200){
        baseData.shopline_smart_collections = res.data.smart_collections
      }else{
        ElMessage.error(res.message)
      }
      loading.close()
    })
  }
  const get_warehouse = () => {
    const loading = ElLoading.service({lock: true})
    api.lingxingApi.get_warehouse().then((res:any)=>{
      if(res.code==200){
        baseData.warehouselist = res.data
      }else{
        ElMessage.error(res.message)
      }
      loading.close()
    })
  }
  const getSellerList = () => {
    const loading = ElLoading.service({lock: true})
    api.lingxingApi.getSellerList({platform_code:form.platform_code}).then((res:any)=>{
      if(res.code==200){
        baseData.sellerList = res.data.list
      }else{
        ElMessage.error(res.message)
      }
      loading.close()
    })
  }
  const get_all_warehouse_products_list = () => {
    baseData.loading = true
    let shopline_cate_list = [], warehouse_list = []
    if(baseData.shopline_cate_type == "1"){
        let shopline_custom_collections:any = baseData.shopline_custom_collections
        for(var i in shopline_custom_collections){
            for(var j in form.shopline_cate_id){
                if(shopline_custom_collections[i].id == form.shopline_cate_id[j]){
                    shopline_cate_list.push({id : shopline_custom_collections[i].id,title : shopline_custom_collections[i].title})
                }
            }
        }
    }else if(baseData.shopline_cate_type == "2"){
        let shopline_smart_collections:any = baseData.shopline_smart_collections
        for(var w in shopline_smart_collections){
            for(var g in form.shopline_cate_id){
                if(shopline_smart_collections[w].id == form.shopline_cate_id[g]){
                    shopline_cate_list.push({id : shopline_smart_collections[w].id,title : shopline_smart_collections[w].title})
                }
            }
        }
    }
    // let warehouselist:any = baseData.warehouselist
    // for(var x in warehouselist){
    //     for(var t in form.warehouse){
    //         if(warehouselist[x].wid == form.warehouse[t]){
    //             warehouse_list.push({wid : warehouselist[x].wid,name : warehouselist[x].name})
    //         }
    //     }
    // }
  
    api.accessoryApi.get_all_warehouse_products_list({store_id:form.store_id,warehouse_list:form.warehouse_list,shopline_cate_list:shopline_cate_list,shopline_cate_id:form.shopline_cate_id,wids:form.warehouse,locations_id:form.locations_id}).then((res:any)=>{
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        tableData.data = res.data.data
        tableData.total = res.data.total
      }else{
        ElMessage.error(res.message)
      }
      baseData.loading = false
    })
  }
  const get_info = () => { 
    form.shopline_cate_id = []
    form.locations_id = []
    get_locations_list()
    get_custom_collections()
    get_smart_collections()
  }
  onMounted(() => {
    get_warehouse()
    getSellerList()
    console.log('onMounted')
  })
  
return (_ctx: any,_cache: any) => {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_card, { shadow: "never" }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_breadcrumb, {
          class: "breadcrumb",
          separator: "/"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_breadcrumb_item, null, {
              default: _withCtx(() => [
                _createTextVNode("同步数据")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          class: "editbtn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (get_all_shopline_products()))
        }, {
          default: _withCtx(() => [
            _createTextVNode("获取所有的shopline商品")
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_form, {
          model: form,
          "label-width": "180px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "平台" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: form.platform_code,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.platform_code) = $event)),
                  placeholder: "Select"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "SHOPLINE",
                      value: 10016
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("SHOPLINE")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "领星店铺" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: form.store_id,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.store_id) = $event)),
                  placeholder: "Select",
                  onChange: _cache[3] || (_cache[3] = ($event: any) => (get_info()))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(baseData.sellerList, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.store_id,
                        label: item.store_name,
                        value: item.store_id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "shopline分类" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: baseData.shopline_cate_type,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((baseData.shopline_cate_type) = $event)),
                  onChange: _cache[5] || (_cache[5] = ($event: any) => (canclecateid()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, {
                      value: "1",
                      label: "1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("手动分类")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, {
                      value: "2",
                      label: "2"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("智能分类")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (baseData.shopline_cate_type=='1')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "手动分类"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: form.shopline_cate_id,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.shopline_cate_id) = $event)),
                      placeholder: "Select",
                      multiple: "",
                      filterable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(baseData.shopline_custom_collections, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            label: item.title,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (baseData.shopline_cate_type=='2')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 1,
                  label: "智能分类"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: form.shopline_cate_id,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.shopline_cate_id) = $event)),
                      placeholder: "Select",
                      multiple: "",
                      filterable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(baseData.shopline_smart_collections, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            label: item.title,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, { label: "shopline地点" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: form.locations_id,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.locations_id) = $event)),
                  placeholder: "Select",
                  multiple: "",
                  filterable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(baseData.locations_list, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.name,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "库存" }, {
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                  border: "",
                  data: tableData.data,
                  style: {"width":"100%"},
                  onSelectionChange: handleSelectionChange
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      type: "selection",
                      label: "同步",
                      width: "55"
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "cate_name",
                      label: "shopline分类"
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "sku",
                      label: "sku"
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "msku",
                      label: "msku"
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "store_name",
                      label: "店铺"
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "locations_name",
                      label: "地点"
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "warehouse",
                      label: "配对仓库"
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "product_valid_num",
                      label: "总领星库存",
                      width: "100"
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "inventory_quantity",
                      label: "shopline后台库存",
                      width: "160"
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "value",
                      label: "差异",
                      width: "80"
                    })
                  ]),
                  _: 1
                }, 8, ["data"])), [
                  [_directive_loading, baseData.loading]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "success",
                  onClick: get_all_warehouse_products_list
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("获取库存")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  type: "success",
                  onClick: update_shopline_products_available
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("更新shopline库存")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ])
    ]),
    _: 1
  }))
}
}

})